import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Award, TrendingUp, Zap } from 'lucide-react';
import PageHeader from './PageHeader';
import SpotlightCard from './SpotlightCard';
import BrandMark from './BrandMark';
import './History.css';

const History = () => {
  const timeline = [
    {
      year: '2001',
      title: 'Fundação',
      description: <>Fundada com foco em consultoria e serviços voltados para a área de Call Centers, a <BrandMark /> iniciou suas atividades em grandes empresas, sendo responsável pela implantação e operacionalização de aproximadamente 80.000 ramais telefônicos.</>,
      icon: Calendar
    },
    {
      year: '2001-2014',
      title: 'Crescimento e Experiência',
      description: 'Durante 13 anos atuamos em diversos clientes nacionais e internacionais onde coletamos diversas experiências e soluções o que nos possibilitou formatar uma metodologia diferenciada e assumir um novo posicionamento no mercado.',
      icon: TrendingUp
    },
    {
      year: '2014',
      title: 'Reformulação',
      description: <>Reformulamos a empresa e a gama de serviços, conquistamos grandes parcerias e nasce a <BrandMark /> Tecnologia com foco em soluções personalizadas que agreguem valor a um custo justo e preocupada com a questão socioambiental.</>,
      icon: Zap
    },
    {
      year: '2026',
      title: 'Multisserviços',
      description: 'Completamos 25 anos de atuação e passamos a adotar uma metodologia de multisserviços atendendo os clientes em praticamente toda sua necessidade, da implantação a manutenção. Com o conceito de fornecedor único.',
      icon: Award
    }
  ];

  return (
    <>
      <PageHeader
        title="Nossa História"
        subtitle="25 Anos de Inovação e Soluções em Tecnologia"
        breadcrumb="História"
      />

      <section className="history section">
        <div className="container">
          <motion.div
            className="history-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="history-description-lead">
              Fundada em 2001 com foco em consultoria e serviços voltados para a área de Call Centers,
              a <BrandMark /> iniciou suas atividades em grandes empresas, sendo responsável pela implantação e
              operacionalização de aproximadamente 80.000 ramais telefônicos.
            </p>
          </motion.div>

          <div className="timeline-section">
            <div className="timeline">
              {timeline.map((item, index) => (
                <motion.div
                  key={index}
                  className="timeline-item-wrapper"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <SpotlightCard className="timeline-card" spotlightColor="rgba(220, 38, 38, 0.05)">
                    <div className="timeline-content-inner">
                      <div className="timeline-header">
                        <span className="timeline-year">{item.year}</span>
                        <div className="timeline-icon">
                          <item.icon size={20} />
                        </div>
                      </div>
                      <h3 className="timeline-title">{item.title}</h3>
                      <p className="timeline-description">{item.description}</p>
                    </div>
                  </SpotlightCard>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default History;
